let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("5g5GD"), load("5HsIb"), load("gr3fi")]).then(() => parcelRequire('h595R'));